import {type VariantProps, cva} from 'class-variance-authority'

export {default as Badge} from './Badge.vue'

export const badgeVariants = cva(
    'inline-flex items-center rounded-md px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset',
    {
        variants: {
            variant: {
                default:
                    'bg-gray-50 text-gray-600 ring-gray-500/10',
                success:
                    'bg-green-50 text-green-700 ring-green-600/20',
                warning:
                    'bg-yellow-50 text-yellow-800 ring-yellow-600/20',
                destructive:
                    'bg-red-50 text-red-700 ring-red-600/10',
                info:
                    'bg-blue-50 text-blue-700 ring-blue-700/10',
                dark:
                    'bg-gray-500 text-white ring-gray-700/10',
                primary:
                    'bg-primary text-white ring-primary/10',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
)

export type BadgeVariants = VariantProps<typeof badgeVariants>
